import React from "react";
import "./SkeletonStyle/SkeletonStyle.css";

export const SubscriptionTableSkeleton = ({
  title = "Loading",
  buttonWidth = "150px",
}) => {
  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div
          className="skeleton"
          style={{ width: "180px", height: "34px", marginBottom: "0" }}
        ></div>
        <div
          className="skeleton"
          style={{ width: buttonWidth, height: "44px", marginBottom: "0" }}
        ></div>
      </div>

      <div className="rolesTable" style={{ marginTop: "10px" }}>
        <div className="RolesHeader">
          <div
            className="skeleton"
            style={{ width: "140px", height: "20px", marginBottom: "0" }}
          ></div>
        </div>

        <div style={{ padding: "1.5rem" }}>
          {Array.from({ length: 4 }).map((_, index) => (
            <div
              key={`${title}-${index}`}
              style={{
                display: "grid",
                gridTemplateColumns: "1.3fr 1fr 1fr 0.7fr",
                gap: "1rem",
                marginBottom: "1rem",
              }}
            >
              <div
                className="skeleton"
                style={{ width: "100%", height: "24px", marginBottom: "0" }}
              ></div>
              <div
                className="skeleton"
                style={{ width: "100%", height: "24px", marginBottom: "0" }}
              ></div>
              <div
                className="skeleton"
                style={{ width: "100%", height: "24px", marginBottom: "0" }}
              ></div>
              <div
                className="skeleton"
                style={{ width: "100%", height: "24px", marginBottom: "0" }}
              ></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
